import { createAction, handleActions } from 'redux-actions';

const ACTIVE_SETTING_MENU = 'statusmenu/ACTIVE_SETTING_MENU';
const ACTIVE_SIDE_MENU = 'statusmenu/ACTIVE_SIDE_MENU';
const ACTIVE_QUICK_MENU = 'statusmenu/ACTIVE_QUICK_MENU';
const ACTIVE_FEEDBACK_MODAL= 'statusmenu/ACTIVE_FEEDBACK_MODAL';
const ACTIVE_VOICE= 'statusmenu/ACTIVE_VOICE';
const ACTIVE_IOSVOICE= 'statusmenu/ACTIVE_IOSVOICE';
const ACTIVE_ORGANIZATION= 'statusmenu/ACTIVE_ORGANIZATION';
const DISABLE_ALL_MENU = 'statusmenu/DISABLE_ALL_MENU';

export const isActiveSettingMenu = createAction(ACTIVE_SETTING_MENU);
export const isActiveSideMenu = createAction(ACTIVE_SIDE_MENU);
export const isActiveQuickMenu = createAction(ACTIVE_QUICK_MENU);
export const isACtiveFeedbackModal = createAction(ACTIVE_FEEDBACK_MODAL);
export const isACtiveVoice = createAction(ACTIVE_VOICE);
export const isACtiveIosVoice = createAction(ACTIVE_IOSVOICE);
export const isACtiveOrganization = createAction(ACTIVE_ORGANIZATION);

export const disableAllMenu = createAction(DISABLE_ALL_MENU);

const initialState = {
  settingMenu:false,
  sideMenu:false,
  quickMenu:false,
  voice:false,
  iosvoice:false,
  organizStatus:false,
  feedbackModal:{
    status:false,
    id:''
  },
};

const isActive = handleActions(
  {
    [ACTIVE_SETTING_MENU]: state => ({...state , settingMenu: !state.settingMenu}),
    [ACTIVE_SIDE_MENU]: state => ({...state , sideMenu: !state.sideMenu}),
    [ACTIVE_QUICK_MENU]: state => ({...state , quickMenu: !state.quickMenu}),
    [ACTIVE_VOICE]: state => ({...state , voice: !state.voice}),
    [ACTIVE_IOSVOICE]: state => ({...state , iosvoice: !state.iosvoice}),
    [ACTIVE_ORGANIZATION]:state =>({...state , organizStatus: !state.organizStatus}),
    [ACTIVE_FEEDBACK_MODAL]:  (state, { payload: feedbackModal }) => feedbackModal,
    [DISABLE_ALL_MENU]: state => initialState
  },
  initialState
);

export default isActive;
